import { __read, __spread, __values } from "tslib";
import template from './item-review-card.html';
export var ItemReviewCardComponent = {
    template: template,
    bindings: {
        item: '<',
        itemRemoved: '<',
        onQuantityUpdate: '&',
        onRemoveItem: '&',
        removingItem: '<',
        updatingQuantity: '<',
        errors: '<',
        limitedStock: '<'
    },
    controller: /** @class */ (function () {
        function ItemReviewCardComponent() {
            'ngInject';
        }
        ItemReviewCardComponent.prototype.$onInit = function () {
            this.displayError = this.doErrorsContainCodes(this.errors, [118, 117, 103]);
        };
        ItemReviewCardComponent.prototype.$onChanges = function (changes) {
            if (changes.item) {
                this.item = Object.assign({}, this.item);
                this.limitedStock = this.limitedStock || this.item.isOnVendorBackOrder;
            }
            if (changes.errors) {
                this.errors = __spread(this.errors);
            }
            if (changes.warnings) {
                this.warnings = Object.assign({}, this.warnings);
            }
        };
        ItemReviewCardComponent.prototype.doErrorsContainCodes = function (errors, codes) {
            var e_1, _a;
            if (errors && errors.length && codes && codes.length) {
                for (var i = 0; i < codes.length; i++) {
                    try {
                        for (var errors_1 = (e_1 = void 0, __values(errors)), errors_1_1 = errors_1.next(); !errors_1_1.done; errors_1_1 = errors_1.next()) {
                            var error = errors_1_1.value;
                            if (error.code === codes[i]) {
                                return true;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (errors_1_1 && !errors_1_1.done && (_a = errors_1.return)) _a.call(errors_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            }
            return false;
        };
        ItemReviewCardComponent.prototype.removeItem = function (itemCode) {
            this.onRemoveItem({
                $event: {
                    itemCode: itemCode
                }
            });
        };
        ItemReviewCardComponent.prototype.updateQuantity = function (_a) {
            var item = _a.item;
            if (!item)
                return;
            this.onQuantityUpdate({
                $event: {
                    item: item
                }
            });
        };
        return ItemReviewCardComponent;
    }())
};
//# sourceMappingURL=item-review-card.component.js.map